import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import type { TAppointment } from '@shared/types/appointment';

export type TAppointmentQuery = {
  name: string;
  o: 'start_time' | '-start_time' | 'created_at' | '-created_at';
  page_number: number;
  page_size: number;
  participant: number;
  participant_email: string;
  platform: TAppointment['platform'];
  status: TAppointment['status'];
  type: TAppointment['type'];
  via_calendly: boolean;
  start_time_after: string;
  start_time_before: string;
  lead?: number;
};

type TMeetingPayload = {
  type: TAppointment['type'];
  host: string | number;
  participant?: string | number;
  name: string;
  interview_type: TAppointment['interview_type'];
  timezone: string;
  description: string;
  start_time: string;

  status?: TAppointment['status'];

  link?: string;
  platform?: TAppointment['platform'];

  country?: string;
  city?: string;
  location?: string;
};

const meetingApi = createCrudService<
  TAppointment,
  TAppointmentQuery,
  TMeetingPayload
>({
  queryKey: [QUERY_KEYS.getAppointments],
  url: 'meetings',
  validateQuery: [QUERY_KEYS.getStagesProgress],
});

export default meetingApi;
